import {
  WORK_AJOUT_REQUETTE,
  WORK_AJOUT_RESET,
  WORK_AJOUT_SUCCES,
  WORK_AJOUT_SUPP,
} from "../constantes/work_terminalConstantes";
export const workAjoutReducer = (
  state = { work: [], loading: false },
  action
) => {
  switch (action.type) {
    case WORK_AJOUT_REQUETTE:
      return {
        ...state,
        loading: true,
      };
    case WORK_AJOUT_SUCCES:
      return {
        ...state,
        work: [...state.work, action.payload],
        loading: false,
      };
    case WORK_AJOUT_SUPP:
      return {
        ...state,
        work: state.work.filter((x) => x.code_art !== action.payload),
      };
    case WORK_AJOUT_RESET:
      return {
        ...state,
        work: [],
        loading: false,
      };
    default:
      return { ...state };
  }
};
